export { VideoWrapper as Video } from './video';
export type { VideoProps } from './video';
